
// Import css files

import sandhl from '../../../../../assets/images/b1iconset.png';
import bankingicon from '../../../../../assets/askTheExpertImages/bankingmenuicon.svg';
import { Link } from "react-router-dom";
import question from '../../../../../assets/images/questionblog.png';
import askimg from "../../../../../assets/homeimages/askbtn.svg";
import expiryclock from '../../../../../assets/images/expiryclock.svg';
import React, { useEffect } from 'react';
import { Trans, useTranslation } from "react-i18next";
import { convertToCanadianDateTime, convertToRoman, decodeHtmlEntities } from "../../../../../shared/helper";

const BankingArticleDetailsV4Jsx = (props) => {
  const {
    detailsData
  } = props;
  const { t } = useTranslation();
  useEffect(() => {
   
    window.scrollTo(0, 0);
  }, [])
  return (
    <>
  <section className="bankinversionfourdetailblog">
        <div className="container">
          <div className="blogsectioone">
            <div className="row">
            <div className="col-lg-7 col-sm-7">
           
            <div className="blogsectioleft">
              <div className="title">
                <h1>{decodeHtmlEntities(detailsData?.title?.rendered)}</h1></div>
              <p>{detailsData?.acf?.variant_4?.banner_sectionn?.description}</p>
            </div>
            <div className="d-flex userdetails">
              <div className="userphoto">
                <img src={`https://ui-avatars.com/api/?name=${detailsData?.['_embedded']?.['author']?.[0]?.name}&rounded=true`} alt={`${detailsData?.['_embedded']?.['author']?.[0]?.name}`} />
              </div>
              <div className="username">{detailsData?.['_embedded']?.['author']?.[0]?.name}</div>
            </div>
            <p className="articlepublishdate d-block d-lg-none d-sm-none d-md-none "><span><img src={expiryclock} alt="clock"/></span>{convertToCanadianDateTime(detailsData?.date)}</p>
            </div>
            <div className="col-lg-5 col-sm-5">
              <div className="blogsectioright">
              <div className="tagreal"><span><img src={bankingicon} alt="Banking Icon" /></span>{detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.name}</div>
                <img src={detailsData?.acf?.variant_4?.banner_sectionn?.image} alt="bannermage"/>
                <p className="articlepublishdate d-none d-sm-block"><span><img src={expiryclock} alt="clock"/></span>{convertToCanadianDateTime(detailsData?.date)}</p>
              </div>
              </div>
            </div>
           
          </div>
         
         
          <div className="blogsectiofour">
            <h2>{detailsData?.acf?.variant_4?.overview_section?.title} </h2>
            <p>{detailsData?.acf?.variant_4?.overview_section?.description}  </p>
            <div className="row">
            {detailsData?.acf?.variant_4?.overview_section?.guide.map((item,index) => (
              <div className="col" key={index}>
                <div className="blogsectiofourinner">
                  <div className="serialnumber">{ String(index+1).padStart(2, '0')}</div>
                  <h4>{item?.title} </h4>
                  <p>{item?.description}</p>
                </div>
              </div>
              ))}

              
            </div>
           
          </div>
          <div className="blogsectiofive">
            <div className="row">
              <div className="col-lg-6 col-sm-6 flb">
              <div className="blogsectiofiveleft">
              <div className="blogsectiofiveinner">
                 <h2>{detailsData?.acf?.variant_4?.avoid_mistake_section?.title} </h2>
                <p>{detailsData?.acf?.variant_4?.avoid_mistake_section?.description} </p>
              </div>
              <div className="blogsectiofiveimage"><img src={detailsData?.acf?.variant_4?.avoid_mistake_section?.image} alt="blogimage" /></div>
              </div>
              </div>
              <div className="col-lg-6 col-sm-6">
              <div className="blogsectiofivemiddle">
              <div className="blogsectiofivemiddleinner">
                  <ul>
                  {detailsData?.acf?.variant_4?.avoid_mistake_section?.item.map((item,index)=>(
                    <li key={index}>
                     <h4> <span>{convertToRoman(index+1)}</span> {item?.title}</h4>
                      <p>{item?.description}</p>
                    </li>
                    ))}
                   
                  </ul>
                 
              </div>
     
              </div>
              </div>
             
            </div>
          </div>
          <div className="blogsectiothree">
            <div className="row">
              <div className="col-lg-12 col-sm-1">
                <div className="blogsectiothreeright">
                 <h2>{detailsData?.acf?.variant_4?.tips_section?.title} </h2>
                  <ul>
                  {detailsData?.acf?.variant_4?.tips_section?.tips.map((item,index)=>(
                    <li key={index}>
                      <span>{String.fromCharCode(65 + index)}</span>
                      <h4>{item?.title}</h4>
                      <p>{item?.description}</p>
                    </li>
                    ))}
                   
                  </ul>
                </div>
              </div>
            </div>
            
          </div>
          <div className="blogsectiosix">
            <div className="row">
            <div className="col-lg-6 col-sm-6">
                <div className="blogsectiotwoinner">
                  <h2><span><img src={sandhl} alt="blogimage"/></span>{detailsData?.acf?.variant_4?.checklist_section?.title}</h2>
                  <ul>
                  {detailsData?.acf?.variant_4?.checklist_section?.item.map((item,index)=>(
                    <li key={index}>{item?.title}</li>
                    ))}
                   
                  </ul>
                </div>
            </div>
            <div className="col-lg-6 col-sm-6">
            <div className="blogsectiofiveimageset"><img src={detailsData?.acf?.variant_4?.checklist_section?.image} alt="blogimage" /></div>
            </div>
            </div>
         
            </div>
          <div className="blogsectiotwo">
          <div className="blogsectiotwoinner">
            <h2>{detailsData?.acf?.variant_4?.conclusion_section?.title}</h2>
            <div dangerouslySetInnerHTML={{ __html: detailsData?.acf?.variant_4?.conclusion_section?.description }}></div>
            
          </div>
          </div>
          <div className="blogsixsection">
            <div className="d-flex blogsixsectioninner align-items-center">
              <div className="col-lg-1 col-sm-1"><img src={question} alt="blogicon" /></div>
              <div className="col-lg-6 col-sm-6">
              <h2><Trans i18nKey={t("COMMON.BLOGV4TAGONE")}></Trans></h2>
              <p><Trans i18nKey={t("COMMON.BLOGV4TEXT")}></Trans></p>
              </div>
              <div className="blogsixsectioninnerbtn">
                <Link to={'/AskTheExpert'}>
                  <div className={`askbutton`}>
                    <p className={`askres mb-0`}>{t("COMMON.ASKTHEEXPERTS")}</p>
                    <img src={askimg} alt="Ask now" />
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="blogdisclaimer">
       <div className="disclaimerinner">
         <h2>{t("COMMON.Disclaimer_heading")}</h2>
         <p>{t("COMMON.Disclaimer_text")}</p>
       </div>
       </div>
        </div>
      </section>
    </>

  );
};

export default BankingArticleDetailsV4Jsx;
